export const options = [
  {
    id: 'digital-manufacturing-landing',
    type: 'video',
    bgImage: 'https://cdn.printos.com/images/landing-page/2x/Hero.png',
    message: 'start.3DIntro',
    video: {
      id: '93IeL9Xijsw'
    },
  },
  {
    type: 'info-static-row',
    contentImage: 'https://cdn.printos.com/images/landing-page/2x/Transform.png',
    // contentOnRight: true,
    title: 'start.3DTransform_Title',
    message: 'start.3DTransform_Desc',
    bullets: [
      'start.3DTransform_Bullet1',
      'start.3DTransform_Bullet2',
      'start.3DTransform_Bullet3',
      'start.3DTransform_Bullet4',
    ],
  },
  {
    type: 'transition-small',
    title: 'start.3DTogether1',
    message: 'start.3DTogether2',
  },
  {
    type: 'info-static-block',
    bgImage: 'https://cdn.printos.com/images/landing-page/2x/COVID-mask.png',
    align: 'left',
    title: 'start.3DCovid_Title',
    message: 'start.3DCovid_Desc',
    link: {
      title: 'start.LearnMore',
      url: 'https://reinvent.hp.com/us-en-3dprint-COVID-19-containment-applications',
    },
  },
  {
    type: 'transition-large',
    bgImage: 'https://cdn.printos.com/images/landing-page/2x/Clockwork.png',
    title: 'start.3DClockWork_Category',
    message: 'start.3DClockWork_Title',
  },
  {
    type: 'transition-small',
    title: 'start.3DSoftware_Category',
    category: true,
    message: 'start.3DSoftware1',
  },
  {
    type: 'info-dynamic-row',
    title: 'start.3DKPI_Category',
    message: 'start.3DKPI_Category_Title',
    options: [
      {
        id: 'kpi-downtime',
        title: 'start.3DDowntime_Title',
        bgImage: 'https://cdn.printos.com/images/landing-page/2x/Downtime.png',
        bullets: [
          'start.3DDowntime_Bullet1',
          'start.3DDowntime_Bullet2',
        ],
        selected: true,
      },
      {
        id: 'kpi-optimize',
        title: 'start.3DTargets_Title',
        bgImage: 'https://cdn.printos.com/images/landing-page/2x/KPI.png',
        bullets: [
          'start.3DTargets_Bullet1',
          'start.3DTargets_Bullet2',
        ],
        selected: false,
      },
      {
        id: 'kpi-efficiency',
        title: 'start.3DEfficiency_Title',
        bgImage: 'https://cdn.printos.com/images/landing-page/2x/Efficiency.png',
        bullets: [
          'start.3DEfficiency_Bullet1',
          'start.3DEfficiency_Bullet2',
          'start.3DEfficiency_Bullet3',
        ],
        selected: false,
      },
    ],
  },
  {
    type: 'info-static-column',
    title: 'start.3DAnalyze_Category',
    message: 'start.3DAnalyze_Category_Title',
    contentImage: 'https://cdn.printos.com/images/landing-page/1x/Analyze.png',
    options: [
      {
        title: 'start.3DAnalyze_Insights',
        bullets: [
          'start.3DAnalyze_InsightBullet1',
          'start.3DAnalyze_InsightBullet2',
        ],
      },
      {
        title: 'start.3DAnalyze_Track',
        bullets: [
          'start.3DAnalyze_TrackBullet1',
          'start.3DAnalyze_TrackBullet2',
          'start.3DAnalyze_TrackBullet3',
        ],
      },
      {
        title: 'start.3DAnalyze_Collect',
        bullets: [
          'start.3DAnalyze_CollectBullet1',
        ],
      },
    ],
  },
  {
    type: 'info-dynamic-row',
    title: 'start.3DOptimize_Category',
    message: 'start.3DOptimize_Category_Title',
    options: [
      {
        id: 'optimize-costs',
        title: 'start.3DCosts_Title',
        bgImage: 'https://cdn.printos.com/images/landing-page/2x/Costs.png',
        bullets: [
          'start.3DCosts_Bullet1',
          'start.3DCosts_Bullet2',
          'start.3DCosts_Bullet3',
        ],
        selected: true,
      },
      {
        id: 'optimize-quality',
        title: 'start.3DQuality_Title',
        bgImage: 'https://cdn.printos.com/images/landing-page/2x/Quality.png',
        bullets: [
          'start.3DQuality_Bullet1',
          'start.3DQuality_Bullet2',
          'start.3DQuality_Bullet3',
        ],
        selected: false,
      },
      {
        id: 'optimize-maintenance',
        title: 'start.3DMaintain_Title',
        bgImage: 'https://cdn.printos.com/images/landing-page/2x/Maintenance.png',
        bullets: [
          'start.3DMaintain_Bullet1',
          'start.3DMaintain_Bullet2',
          'start.3DMaintain_Bullet3',
        ],
        selected: false,
      },
    ],
  },
  {
    type: 'info-static-column',
    title: 'start.3DSupport_Category',
    message: 'start.3DSupport_Category_Title',
    options: [
      {
        title: 'start.3DSupport_Knowledge',
        bullets: [
          'start.3DSupport_KnowledgeBullet1',
        ],
      },
      {
        title: 'start.3DSupport_Support',
        bullets: [
          'start.3DSupport_SupportBullet1',
        ],
      },
    ],
  },
  {
    type: 'table',
    title: 'start.3DPremium_Category',
    message: 'start.3DPremium_Category_Title',
    columns: [
      {
        type: 'text',
        flex: true,
        title: 'start.3DCompare',
      },
      {
        type: 'check',
        title: 'start.3DCenter',
        align: 'center',
      },
      {
        type: 'check',
        title: 'start.3DCenterPremium',
        align: 'center',
      },
    ],
    rows: [
      [
        'start.3DFeature1',
        true,
        true,
      ],
      [
        'start.3DFeature2',
        true,
        true,
      ],
      [
        'start.3DFeature3',
        true,
        true,
      ],
      [
        'start.3DFeature4',
        true,
        true,
      ],
      [
        'start.3DFeature5',
        false,
        true,
      ],
      [
        'start.3DFeature6',
        false,
        true,
      ],
      [
        'start.3DFeature7',
        false,
        true,
      ],
      [
        'start.3DFeature8',
        false,
        true,
      ],
      [
        'start.3DFeature9',
        false,
        true,
      ],
      [
        'start.3DFeature10',
        false,
        true,
      ],
    ],
  }
];
